import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Forside from "./pages/Forside";
import Korekort from "./pages/Korekort";
import Priser from "./pages/Priser";
import Teori from "./pages/Teori";
import Forstehjaelp from "./pages/Forstehjaelp";
import OmCarina from "./pages/OmCarina";
import Kontakt from "./pages/Kontakt";
import Persondata from "./pages/Persondata";
import KoretekniskAnlaeg from "./pages/KoretekniskAnlaeg";
import NotFound from "./pages/NotFound";
import Forbidden from "./pages/Forbidden";

function App() {
  return (
    <div className="flex flex-col min-h-screen bg-brand-light antialiased">
      {/* Header */}
      <Header />

      {/* Main Content Area */}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Forside />} />
          <Route path="/korekort" element={<Korekort />} />
          <Route path="/priser" element={<Priser />} />
          <Route path="/teori" element={<Teori />} />
          <Route path="/koreteknisk-anlaeg" element={<KoretekniskAnlaeg />} />
          <Route path="/forstehjaelp" element={<Forstehjaelp />} />
          <Route path="/om-carina" element={<OmCarina />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="/sea-efterskole" element={<Navigate to="/kontakt?tab=sea-efterskole" replace />} />
          <Route path="/skipper-clement" element={<Navigate to="/kontakt?tab=skipper-clement" replace />} />
          <Route path="/klostermarkskolen" element={<Navigate to="/kontakt?tab=klostermark" replace />} />
          <Route path="/persondata" element={<Persondata />} />
          
          {/* Error Pages */}
          <Route path="/403" element={<Forbidden />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default App;
